import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateHelperService } from '@shared/services/date-helper.service';
import { PriceHelperService } from '@shared/services/price-helper.service';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import {
  ProductReviewData,
  ProductReviewSummary,
} from '../interfaces/product-review.interface';

const apiUrl = environment.apiUrl + 'guest/products/reviews';

@Injectable({
  providedIn: 'root',
})
export class ProductReviewService {
  constructor(
    private http: HttpClient,
    private priceHelper: PriceHelperService,
    private dateHelper: DateHelperService
  ) {}

  getProductReviews(
    productSlug: string,
    itemPerPage: number,
    currentPage: number
  ) {
    return this.http
      .post(apiUrl + '/' + productSlug, {
        item_per_page: itemPerPage,
        current_page: currentPage,
      })
      .pipe(
        map((res: any) => {
          let productReviewData: ProductReviewData = res.data;
          productReviewData.reviews.forEach((review) => {
            review.formattedTimeStamp = this.dateHelper.idTimeStampFormatter(
              review.created_at
            );
            review.replies.forEach((reply) => {
              reply.formattedTimeStamp = this.dateHelper.idTimeStampFormatter(
                reply.created_at
              );
            });
          });
          return productReviewData;
        })
      );
  }

  groupReviewRating(reviewSummary: ProductReviewSummary) {
    let the5Percent = reviewSummary.rate_5
      ? (reviewSummary.rate_5 / reviewSummary.total_review) * 100
      : 0;
    let the4Percent = reviewSummary.rate_4
      ? (reviewSummary.rate_4 / reviewSummary.total_review) * 100
      : 0;
    let the3Percent = reviewSummary.rate_3
      ? (reviewSummary.rate_3 / reviewSummary.total_review) * 100
      : 0;
    let the2Percent = reviewSummary.rate_2
      ? (reviewSummary.rate_2 / reviewSummary.total_review) * 100
      : 0;
    let the1Percent = reviewSummary.rate_1
      ? (reviewSummary.rate_1 / reviewSummary.total_review) * 100
      : 0;
    return [
      {
        star: 5,
        total: this.priceHelper.shortPriceFormatter(reviewSummary.rate_5),
        percent: the5Percent,
      },
      {
        star: 4,
        total: this.priceHelper.shortPriceFormatter(reviewSummary.rate_4),
        percent: the4Percent,
      },
      {
        star: 3,
        total: this.priceHelper.shortPriceFormatter(reviewSummary.rate_3),
        percent: the3Percent,
      },
      {
        star: 2,
        total: this.priceHelper.shortPriceFormatter(reviewSummary.rate_2),
        percent: the2Percent,
      },
      {
        star: 1,
        total: this.priceHelper.shortPriceFormatter(reviewSummary.rate_1),
        percent: the1Percent,
      },
    ];
  }
}
